import { Box, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import QuickTixLogoWhite from "../../../../../../Images/GX_Logo_White_No_Bg.png";
import QuickTixLogo1 from "../../../../../../Images/GX_Logo_Black_No_Bg.png";
import QrCode from "../../../../../../Images/qrCode1.png";
import moment from "moment";

function Ticket8({ ticket, ChangeColor, type, image, bookerName, navigator }) {
  const qrCodeData = ticket?.qrCode || "";
  const pevSelected = Number(ticket?.prevTicket) === ticket?.id ? true : false;
  return (
    <Box sx={{ height: "100%" }}>
      <Grid
        elevation={0}
        spacing={2}
        sx={{
          height: "100%",
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#E8E8E8",
          border: pevSelected ? "2px solid #4A90E2" : "0px solid #e0e0e0",
          boxShadow: pevSelected
            ? "0 4px 12px rgba(74, 144, 226, 0.5)"
            : "0 2px 8px rgba(0, 0, 0, 0.1)",
          transition: "all 0.1s ease",
          "&:hover": {
            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.2)",
            border: "1px solid #4A90E2",
            borderRadius: "1px",
          },
        }}
      >
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          sx={{
            backgroundColor: ChangeColor
              ? ChangeColor
              : ticket?.bgColor
              ? ticket?.bgColor
              : "#807c79",
            width: "75%",
          }}
          m={"0.3em"}
          position={"relative"}
        >
          <Stack mt={2.5} mb={4} pl={3} sx={{ width: "85%" }}>
            <Stack direction={"row"} justifyContent={"space-between"}>
              <div>
                <img
                  alt=":Logo"
                  src={image ? image : QuickTixLogoWhite}
                  style={{
                    maxWidth: "80%",
                    height: "auto",
                    maxHeight: "92px",
                    objectFit: "contain",
                  }}
                />
              </div>
              <Box
                sx={{
                  height: { xs: "1.5rem", sm: "2rem" },
                  border: "2px solid #fff",

                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h6"
                  Wrap
                  component="div"
                  sx={{
                    fontWeight: 600,
                    fontSize: { xs: "0.5rem", sm: "0.7rem" },
                    color: "#ffff",

                    fontFamily: "Lato",
                    mx: { xs: "0.1rem", sm: "0.5rem" },
                  }}
                  textAlign={"center"}
                >
                  {moment(ticket?.date).format("MM/DD/YYYY")}
                </Typography>
                <Box
                  sx={{
                    width: "2px",
                    color: "#ffff",
                    height: "100%",
                    backgroundColor: "#ffff",
                    mx: "0.3em",
                  }}
                />
                <Typography
                  variant="h6"
                  Wrap
                  component="div"
                  sx={{
                    fontWeight: 600,
                    fontSize: { xs: "0.5rem", sm: "0.7rem" },
                    color: "#ffff",
                    mx: { xs: "0.1rem", sm: "0.5rem" },
                    fontFamily: "Lato",
                  }}
                  textAlign={"center"}
                >
                  {ticket?.time}
                </Typography>
              </Box>
            </Stack>
            <Box>
              <Typography
                variant="h6"
                Wrap
                component="div"
                sx={{
                  fontWeight: 400,
                  fontSize: {
                    xs: "2rem",
                    sm: "2rem",
                    md: "2rem",
                    lg: "2.5rem",
                  },
                  color: "#FFFFFF",
                  fontFamily: "Bebas Neue",
                }}
              >
                {ticket?.title}
              </Typography>
              <Typography
                variant="h6"
                Wrap
                component="div"
                sx={{
                  fontWeight: 600,
                  fontSize: "0.7rem",
                  color: "white",
                  fontFamily: "Lato",
                }}
                mt={0}
              >
                {bookerName ? bookerName : ticket?.organizer}
              </Typography>
            </Box>
            <Typography
              sx={{ fontSize: { xs: "0.8rem", sm: "1rem" }, color: "white" }}
            >
              {ticket?.ticketName ? ticket?.ticketName : "Ticket"}
            </Typography>
          </Stack>
          <Stack
            sx={{
              width: "15%",
              justifyContent: "start",
              alignItems: "center",
              pt: "1rem",
              gap: "1em",
            }}
          >
            <Typography
              variant="h6"
              Wrap
              component="div"
              sx={{
                fontWeight: "bold",
                fontSize: "1rem",
                whiteSpace: "nowrap",
                color: "#fff",
                writingMode: "vertical-rl",
                transform: "rotate(180deg)",
                fontFamily: "Bebas Neue",
                padding: 0,
                margin: 0,
              }}
              textAlign={"center"}
            >
              ${" "}
              {ticket?.price != null && ticket?.price !== ""
                ? ticket?.ticketPrices
                  ? Object.values(ticket?.ticketPrices)[0]
                  : Number(ticket?.price) === 0
                  ? "Free"
                  : Number(ticket?.price) % 1 === 0
                  ? Number(ticket?.price).toFixed(0)
                  : ticket.price
                : "211"}
            </Typography>
            <Typography
              variant="h6"
              Wrap
              component="div"
              sx={{
                fontWeight: "bold",
                fontSize: {
                  xs: "1.5rem",
                  sm: "2rem",
                  md: "2rem",
                  lg: "2.5rem",
                },
                color: "#fff",
                writingMode: "vertical-rl",
                transform: "rotate(180deg)",
                fontFamily: "Bebas Neue",
                padding: 0,
                margin: 0,
              }}
              textAlign={"center"}
            >
              {type ? type : ticket?.type?.[0]?.typeName ?? "VIP"}
            </Typography>
          </Stack>
          <Typography
            variant="h6"
            Wrap
            component="div"
            sx={{
              fontWeight: 500,
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
              color: "#ffff",
              fontFamily: "Lato",
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
              maxWidth: "200px",
              position: "absolute",
              bottom: "5px",
              right: "20px",
            }}
            ml={0.5}
            mt={0}
          >
            {ticket?.location}
          </Typography>
        </Stack>

        <Box
          alignItems={"center"}
          sx={{ display: "flex", flexDirection: "column" }}
          justifyContent={"center"}
          width={"25%"}
          gap={1}
        >
          {navigator === "ct" ? (
            <></>
          ) : !qrCodeData ? (
            <img
              src={QrCode}
              alt="qr"
              style={{
                width: "100%",
                maxWidth: "80%",
                height: "auto",
                maxHeight: "80px",
                objectFit: "contain",
              }}
            />
          ) : (
            <img
              src={ticket?.qrCode || QrCode}
              alt="QR"
              style={{
                width: "100%",
                maxWidth: "100%",
                height: "auto",
                maxHeight: "100px",
                objectFit: "contain",
              }}
            />
          )}
          <Typography
            variant="h6"
            Wrap
            component="div"
            sx={{
              fontWeight: 600,
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
              color: "black",

              fontFamily: "Lato",
            }}
          >
            {ticket?.code}
          </Typography>
          <Stack ml={2}>
            <img
              alt="Logo"
              src={QuickTixLogo1}
              style={{
                width: "100%",
                maxWidth: "80%",
                height: "auto",
                maxHeight: "40px",
                objectFit: "contain",
              }}
            />
          </Stack>
        </Box>
      </Grid>
    </Box>
  );
}

export default Ticket8;